import { createAction } from 'typesafe-actions';
import { PictureSources } from '../types';

export const showPhotosModal = createAction('photosModal/SHOW')();
export const closePhotosModal = createAction('photosModal/CLOSE')();
export const showPhoto = createAction('photosModal/SHOW_PHOTO')<PictureSources | null>();
export const setPhotosCollection = createAction('photosModal/SET_COLLECTION')<PictureSources[]>();
